<template>
  <drawer
    :transition-from-bottom="smallScreen"
    :is-open="drawerOpen"
    @close-drawer="closeDrawer">
    <template #header>
      <h4 class="typeset-3 mb-6">
        {{ t("double-thick-upgrade.drawer.drawer-header") }}
      </h4>
    </template>
    <template #content>
      <overlay
        v-if="!prices"
        absolutely-positioned />
      <div v-else>
        <div class="mb-6">
          <div class="flex justify-between mb-1 items-center">
            <h5 class="typeset-6">
              {{ t("double-thick-upgrade.drawer.standard-card-stock") }}
            </h5>
            <p class="text-ink-4">
              {{ formattedPrice(currentStandardPrice) }}
            </p>
          </div>
          <p class="typeset-4 text-ink-4 mb-3">
            {{ t("double-thick-upgrade.drawer.paper-weight-standard") }}
          </p>
          <p class="text-ink mb-6">
            {{
              t("double-thick-upgrade.drawer.standard-card-stock-description")
            }}
          </p>
        </div>
        <div class="mb-6">
          <div class="flex justify-between mb-1 items-center">
            <h5 class="typeset-6">
              {{ t("double-thick-upgrade.drawer.premium-card-stock") }}
            </h5>
            <p class="text-ink-4">
              {{ formattedPrice(currentThickPrice) }}
            </p>
          </div>
          <p class="typeset-4 text-ink-4 mb-3">
            {{ t("double-thick-upgrade.drawer.paper-weight-premium") }}
          </p>
          <p class="text-ink">
            {{
              t("double-thick-upgrade.drawer.premium-card-stock-description")
            }}
          </p>
        </div>
        <div class="bg-paper p-4 flex flex-col items-center">
          <p
            class="mb-4"
            v-html="
              t('double-thick-upgrade.drawer.paper-weight-explanation-html')
            "></p>
          <img
            class="items-center w-full"
            :src="explainerGraphic" />
        </div>
      </div>
    </template>
  </drawer>
</template>

<script>
import api from "@/app/javascript/api";
import Drawer from "@/app/javascript/components/shared/Drawer.vue";
import Overlay from "@/app/javascript/components/shared/Overlay.vue";
import explainerGraphic from "@/app/assets/images/double-thick-explainer-graphic.png";

export default {
  name: "DoubleThicknessExplainerDrawer",
  components: {
    Drawer,
    Overlay
  },
  props: {
    designableTypeId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      drawerOpen: false,
      explainerGraphic,
      prices: null,
      qty: null,
      smallScreen: false
    };
  },
  computed: {
    standardPricingValues() {
      return this.prices.filter(price => !price.thickness);
    },
    thickPricingValues() {
      return this.prices.filter(price => price.thickness);
    },
    currentStandardPrice() {
      return this.standardPricingValues.find(price => {
        return price.qty === this.qty;
      });
    },
    currentThickPrice() {
      return this.thickPricingValues.find(price => {
        return price.qty === this.qty;
      });
    },
    formattedPrice() {
      return price => {
        return `${price.currencySymbol}${price.price.toFixed(2)}${this.t(
          "double-thick-upgrade.drawer.per-invitation"
        )}`;
      };
    }
  },
  mounted() {
    const xsQuery = window.matchMedia("(max-width: 479px)");
    xsQuery.addListener(this.xsScreenSize);
    this.xsScreenSize(xsQuery);
    window.addEventListener(
      "openDoubleThicknessExplainerDrawer",
      this.openDrawer
    );
  },
  methods: {
    closeDrawer() {
      this.drawerOpen = false;
    },
    async openDrawer(e) {
      this.qty = parseInt(e.detail.qty, 10);
      this.drawerOpen = true;
      this.prices = this.prices || (await this.fetchPrices());
    },
    async fetchPrices() {
      const response = await api.get(
        `/designable_types/${this.designableTypeId}/all_pricing_values`
      );
      return response.data.prices;
    },
    xsScreenSize(mediaQuery) {
      if (mediaQuery.matches) {
        this.smallScreen = true;
      } else {
        this.smallScreen = false;
      }
    }
  }
};
</script>
